module.exports = __webpack_public_path__ + "static/media/Big Background.13904a59.webp";